"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.substract = void 0;
const date_fns_1 = require("date-fns");
const decimal_js_1 = __importDefault(require("decimal.js"));
const chrono_1 = require("../chrono");
const exception_1 = require("../exception");
const unit_1 = require("../unit");
const utils_1 = require("./utils");
const value_1 = require("../value");
const subDate = (a, b) => (0, value_1.newNumberValue)((0, date_fns_1.differenceInDays)((0, chrono_1.dateValueToDate)(a), (0, chrono_1.dateValueToDate)(b)), unit_1.units.day);
const subNumber = (a, b) => (0, utils_1.numberValueBinaryOperator)(a, b, decimal_js_1.default.prototype.sub);
const subRecord = (a, b) => {
    const result = new Map(a.elements);
    for (const [key] of b.elements) {
        result.delete(key);
    }
    return (0, value_1.newRecordValue)(result);
};
const subTime = (a, b) => (0, value_1.newNumberValue)((0, date_fns_1.differenceInSeconds)((0, chrono_1.timeValueToDate)(a), (0, chrono_1.timeValueToDate)(b)), unit_1.units.second);
const subVector = (a, b) => (0, utils_1.vectorValueBinaryOperator)(a, b, exports.substract);
const subNumberFromDate = (a, b) => {
    if (b.unit != null && b.unit.symbol !== "d") {
        throw new exception_1.TypeError("Cannot substract number from date.");
    }
    return (0, chrono_1.dateToDateValue)((0, date_fns_1.sub)((0, chrono_1.dateValueToDate)(a), { days: b.value.toNumber() }));
};
const subNumberFromMonth = (a, b) => {
    let current;
    let delta;
    if (b.unit != null) {
        throw new exception_1.TypeError("Cannot substract number from month.");
    }
    current = a.value;
    delta = b.value;
    if (delta.comparedTo(0) < 0) {
        delta = delta.neg();
        while (delta.comparedTo(0) > 0) {
            if (current === chrono_1.Month.December) {
                current = chrono_1.Month.January;
            }
            else {
                ++current;
            }
            delta = delta.sub(1);
        }
    }
    else {
        while (delta.comparedTo(0) > 0) {
            if (current === chrono_1.Month.January) {
                current = chrono_1.Month.December;
            }
            else {
                --current;
            }
            delta = delta.sub(1);
        }
    }
    return (0, value_1.newMonthValue)(current);
};
const subNumberFromTime = (a, b) => {
    let delta;
    if (b.unit != null) {
        switch (b.unit.symbol) {
            case "s":
                delta = b.value.toNumber();
                break;
            case "min":
                delta = b.value.mul(date_fns_1.minutesInHour).toNumber();
                break;
            case "h":
                delta = b.value.mul(date_fns_1.secondsInHour).toNumber();
                break;
            case "d":
                delta = b.value.mul(date_fns_1.secondsInDay).toNumber();
                break;
            default:
                throw new exception_1.TypeError("Cannot substract number from time.");
        }
    }
    else {
        delta = b.value.toNumber();
    }
    return (0, chrono_1.dateToTimeValue)((0, date_fns_1.sub)((0, chrono_1.timeValueToDate)(a), { seconds: delta }));
};
const subNumberFromVector = (a, b) => (0, utils_1.vectorValueNumberBinaryOperator)(a, b, exports.substract);
const subNumberFromWeekday = (a, b) => {
    let delta;
    let current;
    if (b.unit != null && b.unit.symbol !== "d") {
        throw new exception_1.TypeError("Cannot substract number from weekday.");
    }
    delta = b.value;
    current = a.value;
    if (delta.comparedTo(0) < 0) {
        delta = delta.neg();
        while (delta.comparedTo(0) > 0) {
            if (current === chrono_1.Weekday.Saturday) {
                current = chrono_1.Weekday.Sunday;
            }
            else {
                ++current;
            }
            delta = delta.sub(1);
        }
    }
    else {
        while (delta.comparedTo(0) > 0) {
            if (current === chrono_1.Weekday.Sunday) {
                current = chrono_1.Weekday.Saturday;
            }
            else {
                --current;
            }
            delta = delta.sub(1);
        }
    }
    return (0, value_1.newWeekdayValue)(current);
};
const substract = (a, b) => {
    if (a.type === b.type) {
        switch (a.type) {
            case "Date":
                return subDate(a, b);
            case "Number":
                return subNumber(a, b);
            case "Record":
                return subRecord(a, b);
            case "Time":
                return subTime(a, b);
            case "Vector":
                return subVector(a, b);
        }
    }
    else if (b.type === "Number") {
        switch (a.type) {
            case "Date":
                return subNumberFromDate(a, b);
            case "Month":
                return subNumberFromMonth(a, b);
            case "Time":
                return subNumberFromTime(a, b);
            case "Vector":
                return subNumberFromVector(a, b);
            case "Weekday":
                return subNumberFromWeekday(a, b);
        }
    }
    throw new exception_1.TypeError(`Cannot substract ${a.type.toLowerCase()} from ${b.type.toLowerCase()}.`);
};
exports.substract = substract;
